import { TypographyH3 } from '@talentmesh/ui/components/typography';
import CopyLinkControl from '../../Components/CopyLinkControl';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import { useNotificationContext } from '@/Context/NotificationContext';
import UIStrings from '@/Utils/UIStrings';

function Header() {
    const { openLink } = useInviteCandidateContext();
    const { showSuccessToaster } = useNotificationContext();

    const copyHandler = async () => {
        await navigator.clipboard.writeText(openLink);
        showSuccessToaster('', UIStrings.YourRecruitmentLinkCopied);
    };

    return (
        <div className="flex flex-col gap-2">
            <TypographyH3 className="py-2.5">{UIStrings.InvitationLink}</TypographyH3>
            <CopyLinkControl link={openLink} onClickHandler={copyHandler} />
        </div>
    );
}

export default Header;
